import { unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["id", "disabled"];
const _hoisted_2 = {
  class: "img-container"
};
const _hoisted_3 = {
  class: "disabled-layer"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["src", "onClick"];
const _hoisted_6 = {
  class: "modal-img-container"
};
const _hoisted_7 = ["src"];
import { scrollLock } from '@/common/utils/Util';
import { ref, toRefs, onMounted } from 'vue';
import AppgInput from '@/components/custom/AppgInput.vue';
import Modal from '@/templates/argon-core/Modal';
import { convertURLtoFile, getImagePath } from '@/common/utils/Util';
import { cloneDeep } from 'lodash';
import { VueDraggableNext } from 'vue-draggable-next';
export default {
  __name: 'AppgImgInputList',
  props: {
    label: {
      type: String,
      default: ''
    },
    valid: {
      type: Boolean,
      default: true
    },
    invalidMessage: {
      type: String,
      default: 'false'
    },
    span: {
      type: String,
      default: ''
    },
    _class: {
      type: String,
      default: ''
    },
    files: {
      type: Array,
      default: []
    },
    rawFiles: {
      type: Array,
      default: []
    },
    max: {
      type: Number,
      default: 10,
      validator: value => {
        if (isNaN(value)) return false;
        if (value <= 0) return false;
        return true;
      }
    }
  },
  emits: ['change', 'update:rawFiles'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const {
      label,
      valid,
      invalidMessage,
      span,
      _class,
      files,
      rawFiles,
      max
    } = toRefs(props);
    onMounted(() => {
      optionCheck();
      id.value = `custom-file-input_${Math.random()}`;
      convertFileToRawFiles();
    });
    const id = ref();
    const fileList = ref([]);
    const modalImage = ref('');
    const convertFileToRawFiles = async () => {
      const imgArr = cloneDeep(files?.value ?? []);
      const convertedFiles = imgArr?.filter(elem => elem?.storedFileName)?.map(elem => ({
        file: convertURLtoFile(elem.storedFileName),
        preview: getImagePath(elem.storedFileName)
      })) ?? [];
      updateFilesToParents([...convertedFiles]);
    };
    const prepareAdd = () => document.getElementById(id.value).click();
    const add = async ({
      target
    }) => {
      const files = target.files;
      if (!files || files?.length > 0) {
        for (let i = 0; i < files.length; i++) {
          const load = {
            preview: '',
            file: files[i]
          };
          const reader = new FileReader();
          reader.onload = e => {
            load.preview = e.target.result;
            updateFilesToParents([load]);
          };
          reader.readAsDataURL(files[i]);
        }
      }
      target.value = '';
    };
    const remove = index => {
      const list = cloneDeep(fileList.value);
      list.splice(index, 1);
      updateFilesToParents(list, true);
    };
    const updateFilesToParents = (files = [], replace = false) => {
      let list = [];
      if (replace) list = files;else list = [...fileList.value, ...files];
      if (list.length > max.value) return;
      fileList.value = list;
      emits('update:rawFiles', fileList.value.map(elem => {
        if (elem?.file) return elem.file;else return elem;
      }));
      emits('change', fileList.value.map(elem => {
        if (elem?.file) return elem.file;else return elem;
      }));
    };
    const changeOrder = files => updateFilesToParents(files, true);
    const optionCheck = () => {
      if (!Array.isArray(files.value)) throw Error('이미지 첨부 컴포넌트의 files 반드시 배열이어야 합니다.');
      if (!Array.isArray(rawFiles.value)) throw Error('이미지 첨부 컴포넌트의 rawfiles는 는 반드시 배열이어야 합니다.');
      if (isNaN(max.value)) throw new Error('다중 이미지 첨부 컴포넌트의 max는 반드시 숫자여야만 합니다.');
      if (max.value <= 0) throw new Error('다중 이미지 첨부 컴포넌트의 max는 반드시 양수여야만 합니다.');
    };
    const expand = modalItem => {
      modalImage.value = modalItem;
      scrollLock(true);
    };
    const collapse = () => {
      modalImage.value = '';
      scrollLock(false);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(AppgInput, {
        label: _unref(label),
        valid: _unref(valid),
        span: _unref(span) ?? '',
        _class: _unref(_class),
        "in-valid-message": _unref(invalidMessage)
      }, {
        default: _withCtx(() => [_createElementVNode("input", {
          id: id.value,
          class: "custom-file-input",
          style: {
            "display": "none"
          },
          type: "file",
          accept: "image/*",
          onInput: add,
          ref: "file-input-ref",
          multiple: "true",
          disabled: fileList.value.length == _unref(max)
        }, null, 40, _hoisted_1), _createElementVNode("div", _hoisted_2, [_createElementVNode("button", {
          class: "add-button",
          onClick: prepareAdd
        }, [_withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [[_vShow, fileList.value.length == _unref(max)]]), _cache[0] || (_cache[0] = _createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 448 512",
          class: "img-add"
        }, [_createElementVNode("path", {
          d: "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"
        })], -1))]), _createVNode(_unref(VueDraggableNext), {
          "model-value": fileList.value,
          "onUpdate:modelValue": changeOrder,
          delay: 100,
          options: {
            delay: 50
          },
          "delay-on-touch-only": true,
          class: "composition-box"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: `item_${index}`,
              class: "preview-box"
            }, [(_openBlock(), _createElementBlock("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 512 512",
              class: "xmark",
              onClick: $event => remove(index)
            }, _cache[1] || (_cache[1] = [_createElementVNode("path", {
              d: "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
            }, null, -1)]), 8, _hoisted_4)), _createElementVNode("img", {
              src: item.preview,
              alt: "",
              class: "preview-img",
              onClick: $event => expand(item.preview)
            }, null, 8, _hoisted_5)]);
          }), 128))]),
          _: 1
        }, 8, ["model-value"])]), _createVNode(_unref(Modal), {
          show: !!modalImage.value,
          size: "md",
          "show-close": true,
          onClose: collapse
        }, {
          header: _withCtx(() => _cache[2] || (_cache[2] = [_createElementVNode("h6", null, "Preview", -1)])),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
            src: modalImage.value,
            alt: "",
            class: "modal-img-preview"
          }, null, 8, _hoisted_7)])]),
          _: 1
        }, 8, ["show"])]),
        _: 1
      }, 8, ["label", "valid", "span", "_class", "in-valid-message"]);
    };
  }
};